/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CtmsItemOptionRespVo
 */
export interface CtmsItemOptionRespVo {
    /**
     * 通关类目数据编号
     * @type {number}
     * @memberof CtmsItemOptionRespVo
     */
    code?: number;
    /**
     * 通关类目数据编号
     * @type {number}
     * @memberof CtmsItemOptionRespVo
     */
    id?: number;
    /**
     * 通关类目分类编号
     * @type {number}
     * @memberof CtmsItemOptionRespVo
     */
    ctmsCategoryId?: number;
    /**
     * hsCode编码
     * @type {string}
     * @memberof CtmsItemOptionRespVo
     */
    hsCode?: string;
    /**
     * 通关类目名称(韩文)
     * @type {string}
     * @memberof CtmsItemOptionRespVo
     */
    itemName?: string;
    /**
     * 通关类目名称(英文)
     * @type {string}
     * @memberof CtmsItemOptionRespVo
     */
    itemNameEn?: string;
    /**
     * 通关类目名称(中文)
     * @type {string}
     * @memberof CtmsItemOptionRespVo
     */
    itemNameCn?: string;
    /**
     * 关税税率
     * @type {number}
     * @memberof CtmsItemOptionRespVo
     */
    taxRate?: number;
    /**
     * 增值税税率
     * @type {number}
     * @memberof CtmsItemOptionRespVo
     */
    vatRate?: number;
    /**
     * 是否需要kc认证，0 不需要， 1 需要
     * @type {number}
     * @memberof CtmsItemOptionRespVo
     */
    kcCsertification?: number;
    /**
     * 是否列表通关  0 不是， 1 是
     * @type {number}
     * @memberof CtmsItemOptionRespVo
     */
    list?: number;
    /**
     * 通关类目数据名称
     * @type {string}
     * @memberof CtmsItemOptionRespVo
     */
    name?: string;
}

/**
 * Check if a given object implements the CtmsItemOptionRespVo interface.
 */
export function instanceOfCtmsItemOptionRespVo(value: object): value is CtmsItemOptionRespVo {
    return true;
}

export function CtmsItemOptionRespVoFromJSON(json: any): CtmsItemOptionRespVo {
    return CtmsItemOptionRespVoFromJSONTyped(json, false);
}

export function CtmsItemOptionRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CtmsItemOptionRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'id': json['id'] == null ? undefined : json['id'],
        'ctmsCategoryId': json['ctmsCategoryId'] == null ? undefined : json['ctmsCategoryId'],
        'hsCode': json['hsCode'] == null ? undefined : json['hsCode'],
        'itemName': json['itemName'] == null ? undefined : json['itemName'],
        'itemNameEn': json['itemNameEn'] == null ? undefined : json['itemNameEn'],
        'itemNameCn': json['itemNameCn'] == null ? undefined : json['itemNameCn'],
        'taxRate': json['taxRate'] == null ? undefined : json['taxRate'],
        'vatRate': json['vatRate'] == null ? undefined : json['vatRate'],
        'kcCsertification': json['kcCsertification'] == null ? undefined : json['kcCsertification'],
        'list': json['list'] == null ? undefined : json['list'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CtmsItemOptionRespVoToJSON(json: any): CtmsItemOptionRespVo {
    return CtmsItemOptionRespVoToJSONTyped(json, false);
}

export function CtmsItemOptionRespVoToJSONTyped(value?: CtmsItemOptionRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'id': value['id'],
        'ctmsCategoryId': value['ctmsCategoryId'],
        'hsCode': value['hsCode'],
        'itemName': value['itemName'],
        'itemNameEn': value['itemNameEn'],
        'itemNameCn': value['itemNameCn'],
        'taxRate': value['taxRate'],
        'vatRate': value['vatRate'],
        'kcCsertification': value['kcCsertification'],
        'list': value['list'],
        'name': value['name'],
    };
}

